'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _isNumber = require('lodash/isNumber');

var _isNumber2 = _interopRequireDefault(_isNumber);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _some = require('lodash/some');

var _some2 = _interopRequireDefault(_some);

var _endsWith = require('lodash/endsWith');

var _endsWith2 = _interopRequireDefault(_endsWith);

var _FileUpload = require('../../services/FileUpload');

var _FileSizeError = require('./errors/FileSizeError');

var _FileSizeError2 = _interopRequireDefault(_FileSizeError);

var _FileTypeError = require('./errors/FileTypeError');

var _FileTypeError2 = _interopRequireDefault(_FileTypeError);

require('./FileUploadTemplate.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileUploadTemplate = function (_React$Component) {
  (0, _inherits3.default)(FileUploadTemplate, _React$Component);

  function FileUploadTemplate(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, FileUploadTemplate);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FileUploadTemplate.__proto__ || (0, _getPrototypeOf2.default)(FileUploadTemplate)).call(this, props));

    _this.handleChange = function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(event) {
        var file;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                file = event.target.files[0];

                if (!file) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return _this.uploadFile(file);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.onSuccess = function (response) {
      _this.setState({ placeHolder: response.name });
      _this.props.onSuccess(response);
    };

    _this.resetTargetValue = function (event) {
      var fileEvent = event;
      fileEvent.target.value = null;
    };

    _this.validateFileSize = function (file, fileMaxSize) {
      var fileSize = file.size;
      if ((0, _isNumber2.default)(fileMaxSize) && fileSize > fileMaxSize) {
        _this.props.onFailed(new _FileSizeError2.default('File Size is too large'));
        return false;
      }
      return true;
    };

    _this.validateFileType = function (file, acceptType) {
      if (!(0, _isEmpty2.default)(acceptType)) {
        var fileName = file.name.toLowerCase();
        var acceptTypeArray = acceptType.split(',');
        if (!(0, _some2.default)(acceptTypeArray, function (value) {
          return (0, _endsWith2.default)(fileName, value.toLowerCase());
        })) {
          _this.props.onFailed(new _FileTypeError2.default('File type is inValidate'));
          return false;
        }
      }
      return true;
    };

    _this.uploadFile = function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(file) {
        var _this$props, requestUrls, requestPayload, fileMaxSize, acceptType, onStart;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props = _this.props, requestUrls = _this$props.requestUrls, requestPayload = _this$props.requestPayload, fileMaxSize = _this$props.fileMaxSize, acceptType = _this$props.acceptType, onStart = _this$props.onStart;

                if (onStart) {
                  onStart();
                }

                if (!(_this.validateFileType(file, acceptType) && _this.validateFileSize(file, fileMaxSize))) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 5;
                return (0, _FileUpload.uploadFile)(requestUrls, requestPayload, file).then(function (response) {
                  _this.onSuccess(response);
                }).catch(function (error) {
                  _this.props.onFailed(error);
                });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.state = {
      placeHolder: _this.props.placeHolder
    };
    return _this;
  }

  (0, _createClass3.default)(FileUploadTemplate, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          acceptType = _props.acceptType,
          buttonName = _props.buttonName,
          _props$disabled = _props.disabled,
          disabled = _props$disabled === undefined ? false : _props$disabled;

      var uploadButtonClass = 'btn btn--sm btn-secondary ' + (disabled ? 'disabled file-upload-template--button__disable' : 'file-upload-template__button');
      return _react2.default.createElement(
        'div',
        { className: 'file-upload-template__container' },
        _react2.default.createElement(
          'span',
          { className: uploadButtonClass },
          _react2.default.createElement(
            'span',
            null,
            buttonName
          ),
          _react2.default.createElement('input', { className: 'file-upload-template__input', type: 'file', accept: acceptType, onChange: this.handleChange, onClick: this.resetTargetValue, disabled: disabled })
        ),
        _react2.default.createElement(
          'div',
          { className: 'file-upload-template__text' },
          _react2.default.createElement('input', { type: 'text', placeholder: this.state.placeHolder, disabled: true })
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      return {
        placeHolder: state.placeHolder
      };
    }
  }]);
  return FileUploadTemplate;
}(_react2.default.Component);

FileUploadTemplate.isTimerExpired = false;
exports.default = FileUploadTemplate;